<template>
  <div class="params-list">
    <div v-for="item in goods.props" :key="item.value" class="params-item">
      <div class="name">{{ item[nameKey] }}</div>
      <div class="value">{{ item[valKey] }}</div>
    </div>
  </div>
</template>

<script setup>
import { useUserStore } from '@/stores';
import { computed, inject } from 'vue';
const goods = inject('goods');
const userStore = useUserStore()
const nameKey = computed(() => userStore.language === 'cn' ? 'name' : 'nameEn')
const valKey = computed(() => userStore.language === 'cn' ? 'value' : 'valueEn')
</script>

<style lang="scss" scoped>
.params-list {
  padding-top: 20px;
  width: 1320px;
  margin-bottom: 84px;

  .params-item {
    display: flex;
    border-bottom: 1px dotted #dadee6;
    line-height: 24px;
    height: 54px;
    margin: 0 12px;

    .name {
      font-family: Montserrat;
      text-transform: capitalize;
      width: 320px;
      height: 54px;
      font-size: 16px;
      line-height: 54px;
      min-width: 320px;
      color: $gray-color;
    }

    .value {
      font-family: Montserrat;
      text-transform: capitalize;
      height: 54px;
      font-size: 16px;
      line-height: 54px;
      color: var(--black-color-9);
    }
  }
}
</style>
